import { trigger, transition, style, animate, AnimationTriggerMetadata } from '@angular/animations';
import { ConnectedPosition } from '@angular/cdk/overlay';

/**
 * Shared animation timing for form control animations.
 * Uses Material Design standard easing curve.
 */
export const FORM_CONTROL_ANIMATION_TIMING = '200ms cubic-bezier(0.4, 0, 0.2, 1)';

/**
 * Default overlay panel positions for dropdowns.
 * Prefers below the trigger, falls back to above when near viewport bottom.
 */
export const DROPDOWN_PANEL_POSITIONS: ConnectedPosition[] = [
  { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4 },
  { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -4 },
];

/**
 * Animation for hint/error text that appears below form controls.
 * Slides in from above with fade effect.
 */
export const subscriptAnimation: AnimationTriggerMetadata = trigger('subscriptAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-100%)' }),
    animate(FORM_CONTROL_ANIMATION_TIMING, style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [animate(FORM_CONTROL_ANIMATION_TIMING, style({ opacity: 0, transform: 'translateY(-100%)' }))]),
]);

/**
 * Animation for dropdown/overlay panels.
 * Scales in vertically with fade effect.
 */
export const panelAnimation: AnimationTriggerMetadata = trigger('panelAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scaleY(0.8)' }),
    animate(FORM_CONTROL_ANIMATION_TIMING, style({ opacity: 1, transform: 'scaleY(1)' })),
  ]),
  transition(':leave', [animate('150ms ease-in', style({ opacity: 0 }))]),
]);

/**
 * Animation for collapsible group content.
 * Slides down with height animation on enter, slides up on leave.
 */
export const groupCollapseAnimation: AnimationTriggerMetadata = trigger('groupCollapseAnimation', [
  transition(':enter', [
    style({ opacity: 0, height: 0, overflow: 'hidden' }),
    animate(FORM_CONTROL_ANIMATION_TIMING, style({ opacity: 1, height: '*' })),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate(FORM_CONTROL_ANIMATION_TIMING, style({ opacity: 0, height: 0 })),
  ]),
]);
